app.controller("GeoNotificationController",
	["$scope", "$timeout", "GeoService", function($scope, $timeout, GeoService) {

		$scope.Geo = GeoService;
		$scope.isResolving = false;
		$scope.isDismissed = false;
		$scope.initialized = false;
		$scope.statusText = "Haetaan sijaintia...";

		$scope.$watch("Geo.status", function(newVal) {
			if(newVal == GeoService.statusType.RESOLVING && !$scope.isDismissed) {
				$scope.statusText = "Haetaan sijaintia...";
				$scope.isResolving = true;
				$scope.isDismissed = false;
			}
			else {
				// Timeout, jotta CSS-animaatiot ehtivät mukaan (deskarilla voi
				// näyttää muuten hassulta)
				$timeout(function() {
					$scope.isResolving = false;
				}, 500);
			}

			if(newVal != GeoService.statusType.UNINITIALIZED) {
				$scope.initialized = true;
			}

			if(newVal == GeoService.statusType.RESOLVED) {
				$scope.statusText = "Sijainti haettu!";
				$scope.isDismissed = true;
			}
			else if(newVal == GeoService.statusType.UNAVAILABLE) {
				$scope.statusText = "Sijaintia ei voitu hakea.";
				$scope.isDismissed = true;
			}
			else if(newVal == GeoService.statusType.DENIED) {
				$scope.statusText = "Sijainnin haku käyttäjän estämä.";
				$scope.isDismissed = true;
			}

		});

		$scope.Cancel = function() {
			GeoService.CancelRequest();
		};
	}]
);